import OutOfOffice from './out-of-office.html';
import controller from './out-of-office.controller';

let OutOfOfficeComponent = {
  restrict: 'E',
  bindings: {},
  template: OutOfOffice,
  controller,
  controllerAs: '$ctrl',
  size: 'md',
  windowClass: "hmodal-info animated zoomIn"
};

export default OutOfOfficeComponent;



// WEBPACK FOOTER //
// ./client/pages/timesheet/modals/out-of-office/out-of-office.component.js